import * as React from 'react';
import type { SVGProps } from 'react';

const IconBookmark = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 28" {...props}>
    <path d="M17.06.5v25.843l-8.027-4.715-.253-.148-.254.148L.5 26.344V.5z" stroke="currentColor" />
  </svg>
);

export default IconBookmark;
